import { CachePolicyWithoutEquality } from 'recoil';

const CHANCE_POLICY_MOST_RECENT: CachePolicyWithoutEquality = { eviction: 'most-recent' };

export default CHANCE_POLICY_MOST_RECENT;
